import React from "react";
import { Box, Typography, useTheme, Grid } from "@mui/material";
import { Fingerprint, Devices, AccessTime } from "@mui/icons-material";
import ReactApexChart from "react-apexcharts";

const WidgetHeader = ({ title, icon: Icon }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
      {Icon && <Icon sx={{ color: theme.palette.text.secondary }} />}
      <Typography variant="h6" fontWeight="bold">
        {title}
      </Typography>
    </Box>
  );
};

const AuthAnalytics = ({ data }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const labelColor = theme.palette.text.secondary;

  // Login Methods Donut
  const methodSeries = data?.methods?.map((m) => m.count) || [];
  const methodLabels = data?.methods?.map((m) => m._id) || [];

  // Apps Bar
  const appSeries = [
    {
      name: "Logins",
      data: data?.apps?.map((a) => a.count) || [],
    },
  ];
  const appLabels = data?.apps?.map((a) => a._id) || [];

  // Peak Hours Area
  const hours = data?.peakHours?.map((h) => h._id) || [];
  const hourCounts = data?.peakHours?.map((h) => h.count) || [];

  const peakOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      background: "transparent",
    },
    stroke: { curve: "smooth" },
    xaxis: { categories: hours, labels: { style: { colors: labelColor } } },
    yaxis: { labels: { style: { colors: labelColor } } },
    colors: [theme.palette.secondary.main],
    grid: { borderColor: theme.palette.divider },
    tooltip: { theme: isDark ? "dark" : "light" },
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        height: "100%",
      }}
    >
      <WidgetHeader title="Authentication & Security" icon={Fingerprint} />

      <Grid container spacing={2}>
        {/* <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">Login Methods</Typography>
                        <Box sx={{ minHeight: 200 }}>
                            <ReactApexChart 
                                options={{ 
                                    chart: { type: 'donut', background: 'transparent' },
                                    labels: methodLabels,
                                    colors: [theme.palette.primary.main, theme.palette.error.main, theme.palette.info.main],
                                    legend: { position: 'bottom', labels: { colors: labelColor } }
                                }} 
                                series={methodSeries} 
                                type="donut" 
                                height={250} 
                            />
                        </Box>
                    </Box>
                </Grid> */}

        <Grid item xs={12} md={12}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary">
              Peak Login Hours
            </Typography>
            <Box sx={{ minHeight: 200 }}>
              <ReactApexChart
                options={peakOptions}
                series={[{ name: "Logins", data: hourCounts }]}
                type="area"
                height={200}
              />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              display: "flex",
              justifyContent: "space-around",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box textAlign="center">
              <Typography variant="h5" fontWeight="bold" color="success.main">
                {data?.totalSuccess || 0}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Successful Logins
              </Typography>
            </Box>
            <Box textAlign="center">
              <Typography variant="h5" fontWeight="bold" color="text.primary">
                {data?.totalAttempts || 0}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                OTP Requests
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthAnalytics;
